<template>
  <b-container fluid class="animated fadeIn">
    <div v-show="errorText !== ''" class="alert alert-danger" role="alert" dismissible @dismised="errorText = ''">
      {{errorText}}
    </div>
    <div v-show="success" class="alert alert-success" role="alert" dismissible @dismised="success=false">
      La acción fue completada con éxito
    </div>
    <b-row>
      <b-col md="6" class="mb-3">
          <b-form-group id="nombre"
            horizontal
            :label-cols="4"
            breakpoint="md"
            class="mb-0"
            label="Buscar"
            :invalid-feedback="!isValidText(filterRules.text, false)? 'No es un valor válido' : ''"
            :state="isValidText(filterRules.text, false)"
            description="Este campo de filtro realizará la búsqueda en los nombres de los sellers"
            label-for="nameFormatter">
            <b-input-group>
              <b-form-input :state="isValidText(filterRules.text, false)" id="nameFormatter" v-model="filterRules.text" placeholder="Texto a buscar" />
              <b-input-group-button>
                <b-btn :disabled="!isValidText(filterRules.text, false)" @click="filterTable">Buscar</b-btn>
              </b-input-group-button>
            </b-input-group>
          </b-form-group>
        </b-col>
      <b-col md="6">
        <button class="btn btn-primary float-right mr-2" @click="openOrganizationModal(selected)">Crear seller</button>
      </b-col>
    </b-row>

    <b-row class="mt-3">
      <b-col class="col-md-auto">
        <b-pagination :total-rows="totalRows" :per-page="filterRules.size" v-model="filterRules.from" class="mb-3" />
      </b-col>
      <b-col class="col-md-auto per-page">
        <b-form-group id="perPage" horizontal label="Mostrar por página">
          <b-form-select :options="pageOptions" v-model="filterRules.size" />
        </b-form-group>
      </b-col>
    </b-row>

    <b-row class="mt-3 pb-3">
      <b-col align-self="start" class="b-col__select-sellers">
        <b-form-checkbox></b-form-checkbox> Seleccionar todos los sellers
      </b-col>
      <b-col class="mt-1" style="display: flex; justify-content: flex-end;">
        <b class="mr-1">{{totalRows}}</b> sellers encontrados
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <b-card header-bg-variant="primary" border-variant="primary" header="Lista de sellers">
          <moon-loader :loading="loading" class="mb-2" color="#000" size="30px"></moon-loader>
          <b-table id="mainTable"
            ref="mainTable"
            show-empty
            striped
            hover
            foot-clone
            :sort-by.sync="filterRules.sortBy"
            :sort-desc.sync="filterRules.sortOrder"
            :per-page="filterRules.size"
            :current-page="filterRules.from"
            :items="itemProvider"
            :fields="fields"
            :filter="filter"
            :fixed=true
            responsive=true
            @row-clicked="openOrganizationModal"
            stacked="xl"
            empty-text="No hay sellers para mostrar"
            empty-filtered-text="No hay sellers para mostrar">
          </b-table>
        </b-card>
      </b-col>
    </b-row>

    <b-modal
      header-bg-variant="primary"
      ref="orgInfo"
      centered
      :title="selected.id ? 'Guardar seller' : 'Crear seller'"
      size="lg"
      @hidden="resetModal"
      @ok="handleSave"
      cancel-title="Cancelar"
      :ok-title="selected.id ? 'Guardar' : 'Crear'"
      :ok-disabled="disableSave"
    >
      <b-container fluid>
        <b-row>
          <b-col md="12">
            <b-form-group
              horizontal
              :label-cols="2"
              label="Nombre"
              :invalid-feedback="!state.name? 'El nombre es inválido' : ''"
              :state="state.name"
            >
              <b-form-input v-model="selected.name"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-form-group
              horizontal
              :label-cols="2"
              label="Cuenta Vtex"
              :invalid-feedback="!state.accountName? 'La cuenta es inválida o ya existe' : ''"
              :state="state.accountName"
            >
              <b-form-input :disabled="Boolean(selected.id)"
                v-model="selected.accountName"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-form-group
              horizontal
              :label-cols="2"
              label="Descripción"
              :invalid-feedback="!state.description? 'La descripción es inválida' : ''"
              :state="state.description"
            >
              <b-form-textarea
              :rows="3"
              :max-rows="6"
              v-model="selected.description"
              ></b-form-textarea>
            </b-form-group>
            <p class="counter">Caracteres: {{selected.description? selected.description.length : 0}} / 500</p>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-form-group
              horizontal
              :label-cols="2"
              label="Razón social"
              :invalid-feedback="!state.businnesName? 'Caracteres inválidos ' : ''"
              :state="state.businnesName"
            >
            <b-form-input v-model="selected.corporateName"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-form-group
              horizontal
              :label-cols="2"
              label="RFC"
              :invalid-feedback="!state.rfc? 'Caracteres inválidos ' : ''"
              :state="state.rfc"
            >
            <b-form-input v-model="selected.corporateDocument"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-form-group
              horizontal
              :label-cols="2"
              label="Régimen fiscal"
              :invalid-feedback="!state.TaxRegime? 'Caracteres inválidos ' : ''"
              :state="state.TaxRegime"
            >
            <b-form-input v-model="selected.regimenFiscal"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-form-group
              horizontal
              :label-cols="2"
              label="Serie"
              :invalid-feedback="!state.serie? 'Serie inválida (Use 2-20 caracteres) ' : ''"
              :state="state.serie"
            >
              <b-form-input v-model="selected.serie"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-form-group
              horizontal
              :label-cols="2"
              label="Email"
              :description="Boolean(verifyEmailInProgress) ? 'Verificando el correo, espere...' : ''"
              :invalid-feedback="emailFeedback"
              :state="state.email && uniqueEmail"
            >
              <b-form-input v-model="emailSeller"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-form-group
              horizontal
              :label-cols="2"
              label="Teléfono"
              :invalid-feedback="!state.phone? 'Ingresa un Teléfono válido' : ''"
              :state="state.phone"
            >
            <b-form-input v-model="selected.phone"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <hr>
        <h6 class="mb-3">Domicilio fiscal</h6>
        <b-row>
          <b-col md="12">
            <b-form-group
              horizontal
              :label-cols="2"
              label="Calle"
              :invalid-feedback="!state.street? 'Caracteres inválidos ' : ''"
              :state="state.street"
            >
            <b-form-input v-model="selected.street"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-form-group
              horizontal
              :label-cols="2"
              label="Código Postal"
              :invalid-feedback="!state.CP? 'Código postal diferente a 5 dígitos' : ''"
              :state="state.CP"
            >
            <b-form-input v-model="selected.postalCode"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-form-group
              horizontal
              :label-cols="2"
              label="Colonia"
              :invalid-feedback="!state.colonia? 'Caracteres inválidos ' : ''"
              :state="state.colonia"
            >
            <b-form-input v-model="selected.neighborhood"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-form-group
              horizontal
              :label-cols="2"
              label="Estado"
              :invalid-feedback="!state.estate? 'Caracteres inválidos ' : ''"
              :state="state.estate"
            >
            <b-form-input v-model="selected.state"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-form-group
              horizontal
              :label-cols="2"
              label="Localidad"
              :invalid-feedback="!state.location? 'Caracteres inválidos ' : ''"
              :state="state.location"
            >
            <b-form-input v-model="selected.location"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-form-group
              horizontal
              :label-cols="2"
              label="Municipio"
              :invalid-feedback="!state.municipality? 'Caracteres inválidos ' : ''"
              :state="state.municipality"
            >
            <b-form-input v-model="selected.city"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-form-group
              horizontal
              :label-cols="2"
              label="No Exterior"
              :invalid-feedback="!state.noExterior? 'Caracteres inválidos ' : ''"
              :state="state.noExterior"
            >
            <b-form-input v-model="selected.numExt"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-form-group
              horizontal
              :label-cols="2"
              label="No Interior"
              :invalid-feedback="!state.noInterior? 'Caracteres inválidos ' : ''"
              :state="state.noInterior"
            >
            <b-form-input v-model="selected.numInt"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-form-group
              horizontal
              :label-cols="2"
              label="País"
              :invalid-feedback="!state.country? 'Caracteres inválidos ' : ''"
              :state="state.country"
            >
            <b-form-input v-model="selected.country"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col offset-md="2">
            <b-img id="logo" thumbnail rounded fluid class="m-3 float-right"
              v-if="Boolean(selected.imageFile)"
              :src="selected.imageFile"
              />
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-form-group
              horizontal
              id="imageToUpload"
              :label-cols="2"
              breakpoint="md"
              :label="!Boolean(selected.imageFile) ? 'Logo' : 'Cambiar Logo'">
              <b-form-file
                ref="fileinput"
                v-model="file"
                accept="image/*"
                placeholder="Seleccione una imagen...">
              </b-form-file>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-form-group
              horizontal
              :label-cols="2"
              label="Términos y legales"
              :invalid-feedback="!state.terms? 'Los Términos y legales son obligatorios' : ''"
              :state="state.terms"
            >
              <b-form-textarea
              :rows="3"
              :max-rows="6"
              v-model="selected.terms"></b-form-textarea>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="false">
          <b-col md="12">
            <b-form-group
              horizontal
              :label-cols="2"
              label="Dirección"
              :invalid-feedback="!state.address? 'La dirección es inválida' : ''"
              :state="state.address"
            >
              <b-form-input v-model="selected.address"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
      </b-container>
    </b-modal>
  </b-container>
</template>
<script>
  import { OrganizationService, AdminServiceMixin } from '@/mixims/AdminServiceMixin'
  import { ValidationsMixim } from '@/mixims/ValidationsMixim'
  import MoonLoader from 'vue-spinner/src/MoonLoader.vue'
  import appConfig from '@/config/applicationConfig.js'

  export default {
    components: { MoonLoader },
    mixins: [OrganizationService, ValidationsMixim, AdminServiceMixin],
    data: function () {
      return {
        SellerSelected: [],
        success: null,
        errorText: '',
        loading: false,
        fields: [
          { key: 'accountName', label: 'Cuenta Vtex', 'class': 'text-left', sortable: true },
          { key: 'name', label: 'Nombre', 'class': 'text-left', sortable: true },
          { key: 'description', label: 'Descripción', 'class': 'text-left', sortable: true }
        ],
        modal: {},
        selected: {},
        allSellers: null,
        file: null,
        filterRules: {
          sortBy: 'accountName',
          sortOrder: true,
          size: 10,
          from: 1,
          text: null
        },
        totalRows: 0,
        pageOptions: [ 10, 15, 25, 50, 100 ],

        verifyEmailInProgress: false,
        uniqueEmail: true,
        emailFeedback: '',
        emailTimeout: null,
        prevEmail: ''
      }
    },
    mounted () {
      // console.info()
    },
    methods: {
      selectrSellers (rid) {
        const indexOfItem = this.SellerSelected.indexOf(rid)
        if (indexOfItem !== -1) {
          this.SellerSelected.splice(indexOfItem, 1)
        } else if (indexOfItem === -1) {
          this.SellerSelected.push(rid)
        }
      },
      filter () {
        return this.filterRules
      },
      handleSave () {
        let toSave = {...this.selected}
        let imgData = this.file ? {img: this.file} : null
        // console.info(toSave)
        // console.warn(imgData)
        this.saveOrganization(toSave).then(
          (res) => {
            if (imgData) {
              return this.uploadImage(res.body.id, imgData.img).then(
                () => {
                  this.success = true
                  this.$refs.mainTable.refresh()
                }
              )
            } else {
              this.success = true
              this.$refs.mainTable.refresh()
            }
          },
          (error) => {
            this.errorText = error.body.message || 'Ocurrió un error el guardar la seller'
          }
        )
      },
      openOrganizationModal (org) {
        this.loading = true
        let _this = this
        this.errorText = ''
        this.success = false

        this.getAllOrganizations().then(
          (sellers) => {
            _this.loading = false
            _this.allSellers = sellers
            _this.selected = {...org}
            _this.$refs.orgInfo.show()
          },
          () => {
            this.errorText = 'Error obteniendo el listado actualizado de Sellers'
          }
        )
      },
      resetModal () {
        this.selected = {}
        this.file = null
        this.allSellers = null
        this.$refs.fileinput.reset()

        this.uniqueEmail = true
        this.verifyEmailInProgress = false
        this.emailFeedback = ''
        clearTimeout(this.emailTimeout)
        this.prevEmail = ''
      },
      filterTable () {
        this.$refs.mainTable.refresh()
      },
      itemProvider (ctx) {
        this.loading = true
        let filter = ctx.filter()
        return this.getOrganizations(filter).then(
          response => {
            this.totalRows = parseInt(response.headers.get('X-Total-Count'))
            this.loading = false
            return response.body
          },
          error => {
            this.errorText = error.body.message || 'Error obteniendo el listado de sellers'
            this.loading = false
            return []
          }
        )
      },
      uploadImage: function (id, img) {
        let formData = new FormData()
        let endPoint = `${appConfig.API_END_POINT}/admin/organization/${id}/image`
        formData.append('file', img)
        return this.$http.post(endPoint, formData, {
          headers: {
            Authorization: `Bearer ${this.$store.state.access_token}`
          }
        }).catch(() => {
          this.errorText = 'Ocurrio un error al cargar la imagen'
        })
      },
      existsSeller: function (seller) {
        return this.allSellers.find(itemSeller => itemSeller.accountName === seller)
      }
    },
    computed: {
      disableSave () {
        return Object.values(this.state).includes(false) || this.loading
      },
      emailSeller: {
        set (newVal) {
          this.uniqueEmail = false
          this.selected.email = newVal
          // Si estamos editando y el valor es el mismo que antes
          if (this.selected.id && this.prevEmail === newVal) {
            this.uniqueEmail = true
            clearTimeout(this.emailTimeout)
            return
          }

          // Validar formato básico
          if (!newVal || newVal === '') {
            this.emailFeedback = 'El email es obligatorio'
            return
          }
          if (!this.validateEmail(newVal, true)) {
            this.emailFeedback = 'Email inválido'
            return
          }

          // Verificar si ya existe
          this.verifyEmailInProgress = true
          clearTimeout(this.emailTimeout)
          this.emailTimeout = setTimeout(() => {
            this.existEmail(newVal || '').then(res => {
              this.verifyEmailInProgress = false
              const emailExists = res.body
              if (emailExists) {
                this.emailFeedback = 'El correo ingresado se encuentra en uso'
                this.uniqueEmail = false
              } else {
                this.emailFeedback = ''
                this.uniqueEmail = true
              }
            }).catch(() => {
              this.verifyEmailInProgress = false
              this.emailFeedback = 'Error al verificar el email'
              this.uniqueEmail = false
            })
          }, 2000)
        },
        get () {
          return this.selected.email
        }
      },
      state () {
        return {
          name: this.isValidText(this.selected.name, true, 41),
          accountName: Boolean(this.selected.id) || (this.isValidTextOneWord(this.selected.accountName, true, 41) && !this.existsSeller(this.selected.accountName)),
          description: this.isValidTextArea(this.selected.description, true, 500),
          terms: this.isValidTextArea(this.selected.terms, false),
          address: this.isValidText(this.selected.address, false),
          businnesName: this.isValidTextWithoutAccents(this.selected.corporateName, true, 25),
          rfc: this.isValidText(this.selected.corporateDocument, true, 25),
          street: this.isValidText(this.selected.street, true, 50),
          CP: this.isValidText(this.selected.postalCode, true, 5) && this.selected.postalCode.length === 5,
          colonia: this.isValidTextWithoutAccents(this.selected.neighborhood, true, 50),
          estate: this.isValidTextWithoutAccents(this.selected.state, true, 50),
          location: this.isValidText(this.selected.location, true, 50),
          municipality: this.isValidTextWithoutAccents(this.selected.city, true, 50),
          noExterior: this.isValidText(this.selected.numExt, true, 25),
          noInterior: this.isValidText(this.selected.numInt, false, 25),
          country: this.isValidText(this.selected.country, true, 25),
          TaxRegime: this.isValidText(this.selected.regimenFiscal, true, 25),
          serie: this.isValidText(this.selected.serie, true, 20) && this.isValidMinLength(this.selected.serie, 2),
          email: this.validateEmail(this.selected.email, true) && this.isValidTextWithoutAccents(this.selected.email, true) && this.uniqueEmail,
          phone: !isNaN(this.selected.phone) && this.isValidText(this.selected.phone, true, 20)
        }
      }
    },
    watch: {
      selected (newVal, oldVal) {
        if (newVal.id !== oldVal.id) {
          this.prevEmail = newVal.email
        }
      }
    }
  }
</script>
<style lang="scss">
  .overflow-ellipsis {
    text-overflow: ellipsis;
  }
  #logo {
    width: 75px!important;
    height: 75px!important;
  }
  .counter {
    float: right;
    font-size: 10px;
    font-weight: 700;
  }
  .b-col__select-sellers{
    // border:1px solid red;
    display: flex;
    align-items: center;
    .custom-control.custom-checkbox{
      margin: 0px !important;
    }
  }
  /* .custom-table{
    width: 120px !important;
    min-width: 120px !important;
    max-width: 120px !important;
  }

  .custom-table div label{
    margin: 0px !important;
  } */
</style>



// WEBPACK FOOTER //
// src/components/user/OrganizationList.vue